import { c as _c } from "react/compiler-runtime";
import { Typography } from '@repo/ui/Typography';
import { type ElementType, Fragment } from 'react';
import { renderStructuredContent } from '../../renderContext';
import { markNestedTypes } from '../../utils';
import type { TypeProps } from './types';
export const Type = t0 => {
  const $ = _c(9);
  const {
    props
  } = t0;
  const {
    isNested: t1
  } = props;
  const isNested = t1 === undefined ? false : t1;
  let tag = isNested ? "span" : "p";
  if (props.bold) {
    tag = "strong";
  }
  if (props.italic) {
    tag = "em";
  }
  const t2 = tag;
  const t3 = props.bold ? "[700]" : "[inherit]";
  const t4 = props.italic ? "italic" : "normal";
  let t5;
  if ($[0] !== t3 || $[1] !== t4) {
    t5 = {
      fontWeight: t3,
      fontStyle: t4,
      lineHeight: "inherit",
      fontSize: "inherit"
    };
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== props.children) {
    t6 = [props.children].flat().map(_temp);
    $[3] = props.children;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t5 || $[6] !== t6 || $[7] !== tag) {
    t7 = <Typography as={t2} css={t5}>{t6}</Typography>;
    $[5] = t5;
    $[6] = t6;
    $[7] = tag;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};
function _temp(child, idx) {
  if (typeof child === "string") {
    return <Fragment key={`sc-type-${idx}`}>{child}</Fragment>;
  }
  return <Fragment key={`sc-type-doc-${idx}`}>{renderStructuredContent(markNestedTypes(child))}</Fragment>;
}